export default {
	SILVER: 'silver',
	GOLD: 'gold',
	CART: 'cart',
	SCHOOL: 'school',
	DISTRICT: 'district',
	PLATINUM: 'platinum',
}
